import { render } from "./KonvaSectorEditor.vue?vue&type=template&id=84787688&scoped=true"
import script from "./KonvaSectorEditor.vue?vue&type=script&lang=js"
export * from "./KonvaSectorEditor.vue?vue&type=script&lang=js"

import "./KonvaSectorEditor.vue?vue&type=style&index=0&id=84787688&lang=scss&scoped=true"

import exportComponent from "d:\\Beks\\EasyTicket\\easyticket.webshop.admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84787688"]])

export default __exports__